import * as React from 'react';
// import 'react-slideshow-image/dist/styles.css';
import { ImageSlider } from '../ImageSlider';
import './ProductRelatedProducts.styles.less';
import { IProductRelatedProductsProps } from "./ProductRelatedProducts.types";

export const ProductRelatedProducts = (props: IProductRelatedProductsProps) => {
        const responsiveSettings = [
        {
            breakpoint: 800,
            settings: {
                
                slidesToScroll: 5,
                slidesToShow: 5,
            }
        },
        {
            breakpoint: 500,
            settings: {
                slidesToScroll: 2,
                slidesToShow: 2,
                
            }
        }
    ];
    return <div className="ProductRelatedProducts">
        <h2>{props.title}</h2>
        <ImageSlider slidesToScroll={2} slidesToShow={2} responsiveSettings={responsiveSettings} sliderData={props.relatedProducts} />
    </div>
}